import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/_app/organizations/$organizationId/admin/class-days_/new")({
  beforeLoad: ({ params }) => {
    throw redirect({ to: "/organizations/$organizationId/admin/semesters", params, replace: true });
  },
});
